module.exports = __webpack_public_path__ + "static/Muli-LightItalic-e7c649f904d848900c5ac09772ca4aec.woff";